const getUser = (state: any) => state.user;
const isCustomer = (state: any) => state.user.token.isCustomer;
const getCustomerNumber = (state: any) => state.user.token.customerNumber;
const getSupportSelected = (state: any) => state.user.token.supportSelected;
const getOsaId = (state: any) => state.user.token.osaId;
const getAppId = (state: any) => state.user.token.appId;
const getDateExpired = (state: any) => state.user.token.dateExpired;
const isCallCenterAdmin = (state: any) => state.user.token.isCallCenterAdmin;
const getState = (state: any) => state.user.token.state;
const getKindOfSupport = (state: any) => state.user.token.kindOfSupport;
const getDebtorNumber = (state: any) => state.user.token.debtorNumber;

export default {
  getUser,
  getCustomerNumber,
  getOsaId,
  getAppId,
  isCustomer,
  getDateExpired,
  isCallCenterAdmin,
  getState,
  getKindOfSupport,
  getSupportSelected,
  getDebtorNumber,
};
